var React = require('react');

function IconFacebook (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"21","cy":"21","r":"21","fill":"black","key":0}),React.createElement("path",{"d":"M23.5395 15.6567H25V13.1127C24.748 13.078 23.8814 13 22.8722 13C20.7664 13 19.3238 14.3247 19.3238 16.7593V19H17V21.844H19.3238V29H22.1729V21.8447H24.4027L24.7567 19.0007H22.1722V17.0413C22.1729 16.2193 22.3942 15.6567 23.5395 15.6567Z","fill":"white","key":1})]);
}

IconFacebook.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = IconFacebook;

IconFacebook.default = IconFacebook;
